"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BorderBox = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Box = require("../Box");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * A `div` that has a common border and padding set by default
 * @deprecated: Use `Box` along with props e.g. `border="1px solid" borderColor="black10" p={2}`,
 * as needed.
 */
var BorderBox = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "BorderBox",
  componentId: "sc-18mwadn-0"
})(["border-width:1px;border-style:solid;"]);
exports.BorderBox = BorderBox;
BorderBox.displayName = "BorderBox";
BorderBox.defaultProps = {
  borderColor: "black10",
  p: 2
};
//# sourceMappingURL=BorderBox.js.map